import { useAuthStore } from '../store/authStore';
import {
  resolveCompanyCurrency,
  formatCurrency as formatCurrencyStatic,
  CurrencyInfo,
} from '../utils/currency';

/**
 * Reactive currency for React components. Reads the active company's currency
 * from the auth store, so components re-render if it ever changes (e.g. on login).
 *
 * Returns the resolved CurrencyInfo plus a bound `format()` helper.
 */
export function useCurrency(): CurrencyInfo & {
  format: (amount: number | string | null | undefined, opts?: { fractionDigits?: number; noSymbol?: boolean }) => string;
} {
  const company = useAuthStore((s) => s.user?.company);
  const currency = resolveCompanyCurrency(company);
  return {
    ...currency,
    // formatCurrencyStatic reads the synced module mirror, which tracks the same
    // store value — so the output matches `currency` for the active user.
    format: formatCurrencyStatic,
  };
}
